<template>
  <div>

        <el-table
            :data="$store.getters.getInventoryMasterDataProps.image_list"
            style="width: 100%">
            <el-table-column 
                prop="attachment"
                label="Upload Image" align="center">
                <template slot-scope="scope">
                    <UploadFile 
                        @uploaded="scope.row.image_path=$event"
                        :image_path="scope.row.image_path"
                        :image_width="75"
                        :file_dialog_id="'file_upload'+scope.row.key"
                        :button_style="'width: 100px; top: 5px; position: relative;'"
                        />                 
                </template>
            </el-table-column>
            <el-table-column 
                prop="display_online"
                label="Display Online?" align="center">
                <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.display_online">
                        Yes
                    </el-checkbox>                
                </template>
            </el-table-column>   
            <el-table-column 
                prop="default_online_thumbnail"
                label="Show As Thumbnail" align="center">
                <template slot-scope="scope" v-if="scope.row.display_online">
                    <el-checkbox @change="toggleThumnailStatus(scope.row)" v-model="scope.row.default_online_thumbnail">
                        Yes
                    </el-checkbox>                
                </template>
            </el-table-column>   
            <el-table-column 
                prop="default_online_thumbnail_hover"
                label="Show As Thumbnail Hover" align="center">
                <template slot-scope="scope" v-if="scope.row.display_online">
                    <el-checkbox @change="toggleThumnailHoverStatus(scope.row)" v-model="scope.row.default_online_thumbnail_hover">
                        Yes
                    </el-checkbox>                
                </template>
            </el-table-column>   
                
            <el-table-column
                fixed="right"
                label="">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        <el-tooltip class="item" effect="dark" content="Add">
                          <a @click="$store.commit('addNewInventoryMasterImageRow')" style="cursor: pointer; font-size: 16px;">
                            <i class="el-icon-circle-plus"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.commit('removeInventoryMasterImageRow', scope.row.key)"
                              title="Are you sure to delete this?"
                              >
                                <a slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>

<script>
export default {

    computed: {
        getDocumentList() {
            return this.$store.state.document.props
        }
    },
    methods: {
        toggleThumnailStatus(rowData) {
            this.$store.getters.getInventoryMasterDataProps.image_list.forEach(el => {
                el.default_online_thumbnail = false
            })

            rowData.default_online_thumbnail = !rowData.default_online_thumbnail
        },
        toggleThumnailHoverStatus(rowData) {
            this.$store.getters.getInventoryMasterDataProps.image_list.forEach(el => {
                el.default_online_thumbnail_hover = false
            })

            rowData.default_online_thumbnail_hover = !rowData.default_online_thumbnail_hover
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/ImageList.vue